<template>
  <div :class="{ 'c-dark-theme': false, animated: false, fadeIn: true }">
    <!-- 사이트 및 관제지역관리 --------------------------------------------------------------------------------------------->
    <BCard header-tag="header" footer-tag="footer">
      <div slot="header">
        <BIconBuilding /> <strong> 사이트 설정 </strong>
        <div class="card-header-actions">
          <small class="text-muted">저장소 정보를 관리합니다.</small>
        </div>
      </div>

      <BRow>
        <BCol xl="6">
          <CCard border-color="info"  v-if="site">
            <CCardHeader>
              <BIconBoxSeam class="mr-2" /> <strong> 사이트 정보 </strong>
            </CCardHeader>

            <CCardBody>
              <BForm @submit="siteSubmit">
                <CCard accent-color="info">
                  <CCardHeader> 기본 정보 </CCardHeader>
                  <CCardBody>
                    <BFormGroup
                      size="sm"
                      label="사이트 이름"
                      label-for="name"
                      label-cols-md="3"
                      valid-feedback="사용 가능한 사이트 이름 입니다"
                      invalid-feedback="3자 이상 50자 이하"
                      :state="site.name.length > 2"
                    >
                      <BFormInput
                        size="sm"
                        id="name"
                        v-model="site.name"
                        :state="site.name.length > 2"
                        maxLength="50"
                        required
                        trim
                      />
                    </BFormGroup>

                    <BFormGroup
                      size="sm"
                      label="사이트 주소"
                      label-for="address"
                      label-cols-md="3"
                    >
                      <BFormInput
                        size="sm"
                        id="address"
                        v-model="site.address"
                        maxLength="200"
                        trim
                      />
                    </BFormGroup>

                    <BFormGroup
                      size="sm"
                      label="전화번호"
                      label-cols-md="3"
                      valid-feedback="전화번호 또는 휴대폰 번호 형식 입니다"
                      invalid-feedback="전화번호 입력 에) 02-345-6787, 010-1234-5678"
                      label-for="telNo"
                      :state="isValidExp(site.telNo, 'tel') || isValidExp(site.telNo, 'hp')"
                    >
                      <BFormInput
                        size="sm"
                        id="telNo"
                        v-model="site.telNo"
                        maxLength="50"
                        :state="isValidExp(site.telNo, 'tel') || isValidExp(site.telNo, 'hp')"
                        trim
                      />
                    </BFormGroup>

                    <BFormGroup
                      size="sm"
                      label="팩스번호"
                      label-cols-md="3"
                      valid-feedback="전화번호 형식 입니다."
                      invalid-feedback="팩스번호 입력 에) 02-345-6787"
                      label-for="faxNo"
                      :state="isValidExp(site.faxNo, 'tel')"
                    >
                      <BFormInput
                        size="sm"
                        id="faxNo"
                        v-model="site.faxNo"
                        maxLength="50"
                        :state="isValidExp(site.faxNo, 'tel')"
                        trim
                      />
                    </BFormGroup>
                  </CCardBody>
                </CCard>

                <CCard accent-color="warning">
                  <CCardHeader> 사이트 식별정보 </CCardHeader>
                  <CCardBody>
                    <BFormGroup
                      size="sm"
                      label="서비스 식별 코드"
                      label-for="companyId"
                      label-cols-md="3"
                      valid-feedback="사용 가능한 코드입니다"
                      invalid-feedback="숫자 4자 입력 예) 0009"
                      :state="isValidExp(site.companyId, 'num', 4)"
                    >
                      <BFormInput
                        size="sm"
                        id="companyId"
                        v-model="site.companyId"
                        @input="v => (site.companyId = v.toUpperCase())"
                        :state="isValidExp(site.companyId, 'num', 4)"
                        maxLength="4"
                        required
                        trim
                      />
                    </BFormGroup>

                    <BFormGroup
                      size="sm"
                      label="사이트 식별 코드"
                      label-for="siteId"
                      label-cols-md="3"
                      valid-feedback="사용 가능한 코드입니다"
                      invalid-feedback="16진수 4자 예) 1F30"
                      :state="isValidExp(site.siteId, 'hex', 4)"
                    >
                      <BFormInput
                        size="sm"
                        id="siteId"
                        v-model="site.siteId"
                        :state="isValidExp(site.siteId, 'hex', 4)"
                        @input="v => (site.siteId = v.toUpperCase())"
                        maxLength="4"
                        required
                        trim
                      />
                    </BFormGroup>

                    <BFormGroup
                      size="sm"
                      label="서버 IP 주소"
                      label-for="serverIp"
                      label-cols-md="3"
                      valid-feedback="IP 주소 형식입니다"
                      invalid-feedback="IP 주소  예) 192.168.10.123"
                      :state="isValidExp(site.serverIp, 'ip')"
                    >
                      <BFormInput
                        size="sm"
                        id="serverIp"
                        v-model="site.serverIp"
                        :state="isValidExp(site.serverIp, 'ip')"
                        maxLength="40"
                        required
                        trim
                      />
                    </BFormGroup>
                    <BFormGroup
                      size="sm"
                      label="Gateway IP"
                      label-for="gatewayIp"
                      label-cols-md="3"
                      valid-feedback="IP 주소 형식입니다"
                      invalid-feedback="G/W IP 주소  예) 192.168.10.1"
                      :state="isValidExp(site.gatewayIp, 'ip')"
                    >
                      <BFormInput
                        size="sm"
                        id="gatewayIp"
                        v-model="site.gatewayIp"
                        :state="isValidExp(site.gatewayIp, 'ip')"
                        maxLength="40"
                        required
                        trim
                      />
                    </BFormGroup>

                    <BFormGroup
                      size="sm"
                      label="전송 식별 코드"
                      label-for="senderCode"
                      label-cols-md="3"
                      valid-feedback="식별코드 형식입니다"
                      invalid-feedback="숫자 8자  예) 12345678"
                      :state="isValidExp(site.senderCode, 'num', 8)"
                    >
                      <BFormInput
                        size="sm"
                        id="senderCode"
                        v-model="site.senderCode"
                        :state="isValidExp(site.senderCode, 'num', 8)"
                        maxLength="20"
                        required
                        trim
                      />
                    </BFormGroup>
                  </CCardBody>
                </CCard>

                <CCard accent-color="primary">
                  <CCardHeader> 책임자 정보 </CCardHeader>
                  <CCardBody>
                    <CSelect
                      size="sm"
                      id="managerId"
                      horizontal
                      label="책임자 계정"
                      :value.sync="site.managerId"
                      :options="accountOpts"
                      :state="site.managerId"
                      required
                    />

                    <BFormGroup
                      size="sm"
                      label="책임자 사번"
                      label-for="managerNo"
                      label-cols-md="3"
                    >
                      <BFormInput
                        size="sm"
                        id="managerNo"
                        v-model="site.managerNo"
                        maxLength="50"
                        trim
                      />
                    </BFormGroup>

                    <BFormGroup
                      size="sm"
                      label="책임자 성명"
                      label-for="managerName"
                      label-cols-md="3"
                    >
                      <BFormInput
                        size="sm"
                        id="managerName"
                        v-model="site.managerName"
                        maxLength="50"
                        trim
                      />
                    </BFormGroup>

                    <BFormGroup
                      size="sm"
                      label="책임자 직급"
                      label-cols-md="3"
                      label-for="managerRank"
                    >
                      <BFormInput
                        size="sm"
                        id="managerRank"
                        v-model="site.managerRank"
                        maxLength="50"
                        trim
                      />
                    </BFormGroup>
                  </CCardBody>
                </CCard>

                <BRow>
                  <BCol class="text-right">
                    <BButton
                      block
                      type="submit"
                      variant="primary"
                      :disabled="site.siteId === '' || isSiteSaving === true"
                    >
                      <div
                        class="sk-plane bg-light float-left"
                        style="height: 25px; width: 25px"
                        v-if="isSiteSaving"
                      ></div>
                      사이트 정보 저장
                    </BButton>
                  </BCol>
                </BRow>
              </BForm>
            </CCardBody>
          </CCard>
        </BCol>

        <BCol xl="6">
          <CCard border-color="info">
            <CCardHeader>
              <BIconColumnsGap class="mr-2"/> <strong> 관제지역 정보 </strong>
            </CCardHeader>

            <CCardBody>
              <BRow class="mb-2">
                <BCol>
                  <BInputGroup>
                    <BButton variant="primary" class="mr-3" @click="createArea">
                      <BIconPatchPlusFill />
                      관제지역 생성
                    </BButton>
                  </BInputGroup>
                </BCol>
              </BRow>

              <BRow>
                <BCol>
                  <vue-excel-editor v-model="rows"
                    ref="excelGrid"
                    width="100%"
                    class="mb-1"
                    :page="numOfRecord"
                    :readonly-style="{ backgroundColor: '#4F5040' }"
                    @update="updateCell"
                    @select="selectRecord"
                    :localized-label="editorLabel"
                    filter-row
                  >
                    <vue-excel-column field="_id" type="string" key-field invisible/>
                    <vue-excel-column field="name" type="string" width="100px" label="지역명" sticky/>
                    <vue-excel-column field="description" type="string" width="150px" label="상세정보"/>
                    <vue-excel-column field="order" type="string" width="100px" label="순서"/>
                    <!--                    <vue-excel-column
                                          field="managerId"
                                          type="map"
                                          width="100px"
                                          label="관리자"
                                          :options="accountMap"
                                        />-->
                    <vue-excel-column field="updatedAt" type="date" width="110px" label="수정일" :to-text="toLocalTime" readonly/>
                    <vue-excel-column field="updId" type="string" width="100px" label="수정자" readonly/>
                    <vue-excel-column field="createdAt" type="date" width="110px" label="등록일" :to-text="toLocalTime" readonly/>
                    <vue-excel-column field="regId" type="string" width="100px" label="등록자" readonly/>
                  </vue-excel-editor>
                </BCol>
              </BRow>
              <BRow class="mb-3">
                <BCol lg="8">
                  <BButtonGroup>
                    <BButton variant="primary" @click="applyGroup">
                      <BIconCheckCircleFill /> 설정 반영
                    </BButton>

                    <BButton
                      variant="danger"
                      class="ml-2"
                      @click="deleteRecord"
                      :disabled="selectedGroup === null || isGroupDeleting"
                    >
                      <BIconTrashFill /> 선택 삭제
                    </BButton>
                  </BButtonGroup>
                </BCol>
                <BCol>
                  <BProgress
                    height="2rem"
                    v-show="progCount > 0"
                    :value="progCount"
                    :max="totalCount"
                    variant="warning"
                    show-value
                  />
                </BCol>
              </BRow>

              <CCard v-if="selectedGroup !== null" accent-color="info">
                <CCardHeader>
                  <BBadge variant="secondary">{{ selectedGroup.arCode }}</BBadge>
                  <strong> {{ selectedGroup.name }} </strong>
                </CCardHeader>

                <CTabs>
                  <CTab title="지역관리자" active>
                    <BRow>
                      <BCol>
                        <BFormSelect
                          v-model="selectedUser"
                          :options="filteredSSListOptions"
                          class="dark-mode-select"
                        />
                      </BCol>
                      <BCol>
                        <BButton @click="addUserToArea">추가</BButton>
                        <BButton
                          @click="removeUserFromArea"
                        >
                          삭제
                        </BButton>
                      </BCol>
                    </BRow>
                    <BTable
                      :items="selectedGroupManagers"
                      :fields="groupManagerFields"
                      selectable
                      @row-selected="onRowSelected"
                    />
                  </CTab>
                  <CTab title="탱크정보" >
                    <tank-list class="mt-2" :ar-code="selectedGroup.arCode" simple />
                  </CTab>

                </CTabs>
              </CCard>
            </CCardBody>
          </CCard>


          <CCard border-color="info" class="mt-3" v-if="site">
            <CCardHeader>
              <BIconAppIndicator class="mr-2"/> <strong> 사이트 API Access 설정 </strong>
            </CCardHeader>


            <CCardBody>


            <BFormGroup
              size="sm"
              label="서버 인증토큰"
              label-for="token"
              label-cols-md="3"
              valid-feedback="토큰이 발급되었습니다. 서버인증 토큰을 공유하면 인증이 가능합니다."
              invalid-feedback="다른 호스트/서버에서 이 사이트의 API 호출시 인증토큰이 필요합니다"
              :state="site.token.length!==0"
            >
              <BInputGroup id="token">
                <BFormInput
                  size="sm"
                  v-model="site.token"
                  :state="site.token.length!==0"
                  readonly
                />
                <BButton size="sm" @click="setSiteToken" variant="info">
                  <BIconCreditCard/> 갱신
                </BButton>
                <BButton size="sm" @click="tokenCopyToClipboard" variant="secondary" class="ml-1">
                  <BIconClipboard/> 복사
                </BButton>
              </BInputGroup>
            </BFormGroup>

            <BFormGroup
              v-if="site.tokenExp"
              size="sm"
              label="토큰 만료일"
              label-for="tokenExp"
              description="Site API 호출시 인증토큰이 없으면 Host IP를 체크합니다."
              label-cols-md="3"
              :valid-feedback="'인증 토큰만료 ' + getTokenExpDay()+'일 전'"
              :invalid-feedback="'인증 토큰만료 ' + getTokenExpDay()+'일 남았습니다. 갱신이 필요합니다'"
              :state="getTokenExpDay()>30"
            >
              <BBadge id="tokenExp" class="mt-2 font-sm" variant="primary">{{toLocalYmd(site.tokenExp)}} </BBadge>
            </BFormGroup>

            <!-- allowIpAddrs# -->
            <BFormGroup
              size="sm"  class="mb-1"
              label="접속허용 호스트 IP"
              label-for="allowIpAddrs"
              description="Site API 호출시 접근 허용 IP"
              label-cols-md="3"
              valid-feedback="IP 또는 CIDR 형식입니다"
              invalid-feedback="IP 또는 CIDR 형식으로 입력 예) 192.168.0.0/24"
              :state="isValidExp( inputIpAddr, 'cidr') || isValidExp( inputIpAddr, 'ip')"
            >
              <BInputGroup>
                <BFormSelect size="sm"
                             id="allowIpAddrs"
                             v-model="inputIpAddr"
                             :options="site.allowIpAddrs"
                             :select-size="3" class="theme-select"/>
              </BInputGroup>

              <BInputGroup>
                <BFormInput size="sm" v-model="inputIpAddr"></BFormInput>
                <BButtonGroup>
                  <BButton size="sm" variant="info"
                           @click="setAllowIpAddrs('A',inputIpAddr)"> 추가
                  </BButton>
                  <BButton size="sm" variant="warning"
                           @click="setAllowIpAddrs('D',inputIpAddr)"> 삭제
                  </BButton>

                  <BButton size="sm" variant="danger" class="ml-2"
                           @click="saveAllowIpAddrs">
                    <BIconSave2Fill/> 저장
                  </BButton>
                </BButtonGroup>
              </BInputGroup>
            </BFormGroup>


            <CCard accent-color="warning" class="mt-4">
              <CCardHeader>
                <BIconShieldShaded class="mr-2"/> 데이터 암호키 설정
              </CCardHeader>

              <CCardBody>
              <!------->
                <BFormGroup
                  size="sm"
                  label="API 암호 키"
                  label-for="apiEncMk"
                  label-cols-md="3"
                  description="API 호출시 데이터 암호화를 위한 (encrypted) key"
                >
                  <BFormInput
                    size="sm"
                    id="apiEncMk"
                    type="password"
                    v-model="site.mk"
                    :state="isValidExp(site.mk, 'base64')"
                    maxLength="64"
                    trim
                  />
                </BFormGroup>

                <BFormGroup
                  size="sm"
                  label="초기벡터(IV)"
                  label-for="apiIv"
                  label-cols-md="3"
                >
                  <BFormInput
                    size="sm"
                    id="apiIv"
                    v-model="site.iv"
                    :state="isValidExp(site.iv, 'base64')"
                    readonly
                  />
                </BFormGroup>

                <BFormGroup
                  size="sm"
                  label="KE Key"
                  label-for="apiKeKey"
                  label-cols-md="3"
                >
                  <BFormInput
                    size="sm"
                    id="apiKeKey"
                    type="password"
                    :state="isValidExp(site?.kek, 'base64')"
                    v-model="site.kek"
                    readonly
                  />
                </BFormGroup>

                <BFormGroup
                  size="sm"
                  label="KEK IV"
                  label-for="siteKekIv"
                  label-cols-md="3"
                >
                  <BFormInput
                    size="sm"
                    id="siteKekIv"
                    v-model="site.kiv"
                    :state="isValidExp(site.kiv, 'base64')"
                    readonly
                  />
                </BFormGroup>
                <BRow class="mt-2 mb-2">
                  <BCol>
                    <BInputGroup size="sm" prepend="서버인증토큰" >
                      <BFormInput size="sm"
                                  id="hostToken"
                                  v-model="site.hostToken"
                      />
                    </BInputGroup>

                  </BCol>
                </BRow>

                <BRow>
                  <BCol class="text-right">
                    <BInputGroup size="sm" prepend="키 발급 URL" >

                      <BFormInput size="sm"
                                  id="genKeyUrl"
                                  :state="isValidExp(site.genKeyUrl, 'url')"
                                  v-model="site.genKeyUrl"
                      ></BFormInput>

                      <BButton size="sm" variant="primary" @click="issueApiEncryptionKey">
                        <BIconKeyFill class="mr-1"/> 발급요청
                      </BButton>
                    </BInputGroup>

                  </BCol>
                </BRow>

              </CCardBody>
            </CCard>



            </CCardBody>

          </CCard>
        </BCol>
      </BRow>
    </BCard>
  </div>
</template>

<style src="spinkit/spinkit.min.css"></style> <!--animated processing icon-->

<script>
import "@/common/HelperMixin";
import {
  apiCall,
  cloneVar,
  setAreas,
} from "@/common/utils";
import { ExcelEditorLabel } from "@/common/constants";
import TankList from "../components/TankList";
import moment from "moment";

const _site = {
  siteId: "",
  companyId: "",
  name: "",
  address: "",
  tel1: "",
  tel2: "",
  onlineYn: "",
  department: "",
  senderCode: "",
  managerId: "",
  managerNo: "",
  managerRank: "",
  managerName: "",
  serverIp: "",
  gatewayIp: "",
  token: '',
  tokenExp: '',
  decodedToken: '',
  allowIpAddrs: ['0.0.0.0'],
  mk: "",
  iv: "",
  kek: "",
  kiv: "",
  keyEndAt: null,
  keyIssAt: null,
  keyHmac: '',
  genKeyUrl: '',
  hostToken: ''
};

const _group = {
  arCode: "",
  name: "신규지역",
  description: "",
  managerId: "smartpol",
};

const groupColumnMap = {
  arCode: "지역 코드",
  name: "지역명",
  order: '표시순서',
  description: "지역 상세정보",
  managerId: "지역 책임자",
};

export default {
  name: "Site",
  components: {
    TankList,
  },
  data() {
    return {
      isSiteSaving: false,
      isGroupDeleting: false,
      maps: this.$store.state.codeMaps,
      site: cloneVar(_site),
      accountOpts: [
        { value: "", label: "계정 선택" },
        { value: "smartpol", label: "[smartpol] 시스템 관리자" },
      ],
      accountMap: {
        smartpol: "시스템관리자",
      },
      editorLabel: ExcelEditorLabel,
      selectedGroup: null,
      arCodeMap: {},
      arCodeOpts: [],
      downloadReason: "",
      searchWord: "",
      progCount: 0,
      totalCount: 0,
      rows: [],
      paramMap: {},
      numOfRecord: 10,
      siteFields: {},
      modalTitle: "",
      tankFormShow: false,
      SSList: [],
      selectedUser: "",
      selectedGroupManagers: [],
      groupManagerFields: [
        { key: "userId", label: "사용자 ID" },
        { key: "name", label: "이름" },
        { key: "grade", label: "직급" },
        { key: "position", label: "직책" },
      ],
      inputIpAddr: '',
      selectedIpAddr: ''
    };
  },
  async created(){
    try{
      // await this.setMachineMap();
      await this.getAccounts();

      await this.getSSUsers();

      await this.getSiteInfo();

      await this.getAreaList();

    }catch(err){
      console.error(err);
    }
  },

  mounted() {
    console.log("--- site mounted---------------------");
    // below is not work!
  },
  computed: {
    filteredSSListOptions() {
      const selectedManagerIds = this.selectedGroupManagers.map(manager => manager.userId);
      return this.SSList.filter(user => !selectedManagerIds.includes(user.userId))
        .map(user => ({
          value: user._id,
          text: `${user.name} (${user.userId})`,
        }));
    },
  },
  methods: {
    async issueApiEncryptionKey(){
      try{
        // console.log( this.site );
        const site = this.site;

        if(!site.hostToken){
          return await this.alertDanger('서버인증토큰을 입력하세요')
        }

        if(site.mk && site.iv && site.kek && site.kiv){
          if(!await this.confirmModal('기 발급된 데이터 암호키 셋이 존재합니다. 계속 하시겠습니까?')) return;
        }

        const param = {
          genKeyUrl: site.genKeyUrl,
          hostToken: site.hostToken
        };
        const r = await apiCall("post", `/api/station/request-keyset/${this.site._id}`, param);
        if(r.code===200) {
          this.site = r.result;
          const rst = r.result;
          this.site['kek'] = rst.kek1 + rst.kek2 + rst.kek3 + rst.kek4;
          await this.alertSuccess('암호화 키셋이 정상적으로 발급되었습니다', '암호화 키셋 발급')
        }else{
          await this.alertError(r.message, r.code);
        }

        await this.toastResult(r, '데이터 암호화 키셋 발급');

      }catch(err){
        console.error(err);
        alert(err.message);
      }
    },
    async saveAllowIpAddrs(){
      try{
        const r = await apiCall("put", `/api/station/allow-ip-addrs/${this.site._id}`,
          {allowIpAddrs: this.site.allowIpAddrs}
        );
        if( r.code===200 ) {
          this.site = r.result;
          await this.toastResult( r, '허용 IP정보 설정');
        }
        else await this.alertDanger(r.message, r.code);
      }catch(err){
        console.error(err);
      }

    },
    setAllowIpAddrs(cmd, ip){
      if(cmd==='A'){
        const uniqueSet =  new Set(this.site.allowIpAddrs);
        if( !this.isValidExp(ip, 'cidr') || !this.isValidExp( ip, 'ip')) return alert('CIDR/IP 형식이 아닙니다.');
        uniqueSet.add(ip);
        this.site.allowIpAddrs = [...uniqueSet];
        this.inputIpAddr = '';
      }else if( cmd==='D'){
        this.site.allowIpAddrs = this.site.allowIpAddrs.filter(item => item !== ip);
      }
    },

    async setSiteToken(){
      if(!this.site.senderCode){
        return await this.alertDanger('토큰갱신은 전송식별코드가 필요합니다', '인증토큰 갱신');
      }

      if(!await this.confirmModal('인증토큰을 갱신하시겠습니까? 갱신은 즉시 적용되며, 토큰을 복사하여 접속하는 호스트의 관리자에게 전달해야 함니다', '[인증토큰 갱신]')){
        return;
      }

      try{
        const r = await apiCall("post", `/api/station/token/${this.site._id}`);
        // console.log(r);
        if( r.code===200 ) this.site = r.result;
        else await this.alertDanger(r.message, r.code);
      }catch(err){
        console.error(err);
      }

    },

    getTokenExpDay(){
      return moment(this.site.tokenExp).diff(moment(), 'days');
    },

    async tokenCopyToClipboard(){
      try{
        await navigator.clipboard.writeText(this.site.token);
        alert('인증토큰이 클립보드에 복사되었습니다!');
      }catch(err){
        console.error(err);
      }
    },
    async selectRecord(idx, evt){
      if(!evt){
        this.selectedGroup = null;
        return;
      }
      this.selectedGroup = this.$refs['excelGrid'].getSelectedRecords().pop();
      if (this.selectedGroup) {
        await this.getGroupManagers(this.selectedGroup.arCode);
      }
    },
    async getGroupManagers(groupId) {
      try {
        const r = await apiCall("get", `/api/area/${groupId}/managers`);
        if (r.code === 200) {
          this.selectedGroupManagers = r.result;
        } else {
          await this.alertDanger(r.message, r.code);
        }
      } catch (err) {
        await this.alertDanger(err.message);
      }
    },
    async siteSubmit(evt){
      // console.log('------------- saveSubmit --------------- evt --->', evt );
      evt.preventDefault();

      // 유효성 검사
      const invalidFields = [];
      if (this.site.name.length <= 2) invalidFields.push('사이트 이름');
      if (!this.isValidExp(this.site.telNo, 'tel') && !this.isValidExp(this.site.telNo, 'hp')) invalidFields.push('전화번호');
      if (!this.isValidExp(this.site.faxNo, 'tel')) invalidFields.push('팩스번호');
      if (!this.isValidExp(this.site.companyId, 'num', 4)) invalidFields.push('서비스 식별 코드');
      if (!this.isValidExp(this.site.siteId, 'hex', 4)) invalidFields.push('사이트 식별 코드');
      if (!this.isValidExp(this.site.serverIp, 'ip')) invalidFields.push('서버 IP 주소');
      if (!this.isValidExp(this.site.gatewayIp, 'ip')) invalidFields.push('Gateway IP');
      if (!this.isValidExp(this.site.senderCode, 'num', 8)) invalidFields.push('전송 식별 코드');

      if (invalidFields.length > 0) {
        await this.alertSuccess(`다음 필드가 유효하지 않습니다: ${invalidFields.join(', ')}`, '저장 실패');
        return;
      }
      let r;
      try{
        this.isSiteSaving = true;
        if(this.site._id) {
          // 정보 수정
          r = await apiCall("PUT", `/api/station/${this.site._id}`, this.site);
        }else{
          // 정보 등록
          r = await apiCall("POST", `/api/station`, this.site);
        }
        // console.log( r );
        this.site = r.result;

        if(r.code===200){
          await this.alertSuccess('사이트 정보가 저장 되었습니다.', '사이트 정보');
        }else{
          await this.toastResult( r, '사이트 정보 저장')
        }

      }catch(err){
        console.error( err );
        await this.alertDanger(err.message, r.code, 'danger');
      }finally{
        this.isSiteSaving = false;
      }

    },
    async getSSUsers() {
      try {
        const r = await apiCall("get", `/api/area/user/SS`);
        if (r.code === 200) {
          this.SSList = r.result;
          // console.log('사용자', this.SSList)
        } else {
          await this.alertDanger(r.message, r.code);
        }
      } catch (err) {
        await this.alertDanger(err.message);
      }
    },
    // get SSListOptions() {
    //   return this.SSList.map((user) => ({
    //     value: user._id,
    //     text: `${user.name} (${user.userId})`,
    //   }));
    // },
    async addUserToArea() {
      if (!this.selectedUser || !this.selectedGroup) {
        await this.alertSuccess(`선택된 대상이 없습니다.`);
        return;
      }
      try {
        const r = await apiCall("put", `/api/area/user`, {
          userId: this.selectedUser,
          arCode: this.selectedGroup.arCode,
        });
        this.selectedUser = '';
        this.selectedGroupManager = [];
        if (r.code === 200) {
          await this.getGroupManagers(this.selectedGroup.arCode);
          await this.alertSuccess('사용자가 영역에 성공적으로 추가되었습니다.', '사이트 정보');

          const userIndex = this.SSList.findIndex(user => user._id === this.selectedUser);
          if (userIndex !== -1) {
            this.SSList[userIndex].areas.push(this.selectedGroup._id);
          }
        } else {
          await this.alertDanger(r.message, r.code);
        }
      } catch (err) {
        await this.alertDanger(err.message);
      }
    },
    async removeUserFromArea() {
      if (!this.selectedGroupManager || this.selectedGroupManager?.length === 0)  {
        await this.alertSuccess(`선택된 대상이 없습니다.`);
        return;
      }
      try {
        const r = await apiCall("PUT", `/api/area/user/modify`, {
          userId: this.selectedGroupManager.userId,
          areaId: this.selectedGroup.arCode,
        });
        this.selectedUser = '';
        this.selectedGroupManager = [];
        if (r.code === 200) {
          await this.getGroupManagers(this.selectedGroup.arCode);
          await this.alertSuccess('사용자가 영역에서 성공적으로 제거되었습니다.', '사이트 정보');

          const userIndex = this.SSList.findIndex(user => user.userId === this.selectedGroupManager?.[0]?.userId);
          if (userIndex !== -1) {
            const areaIndex = this.SSList[userIndex].areas.indexOf(this.selectedGroup.arCode);
            if (areaIndex !== -1) {
              this.SSList[userIndex].areas.splice(areaIndex, 1);
            }
          }

        } else {
          await this.alertDanger(r.message, r.code);
        }
      } catch (err) {
        await this.alertDanger(err.message);
      }
    },
    async getSiteInfo(){
      try{
        const r = await apiCall('get', `/api/station`);

        if(r.code===200){
          if(!r.result.length){
            await this.alertWarn('사이트 정보가 없습니다.', '사이트 정보 등록');
            this.site = cloneVar(_site);

          } else {
            const s = this.site;
            this.site = r.result.pop();
            this.site.kek = s.kek1 + s.kek2 + s.kek3 + s.kek4;
          }
        }else{
          await this.alertDanger(r.message, r.code);
        }

      }catch(err){
        await this.alertDanger(err.message);
        console.error( err );
      }
    },
    async getAccounts(){
      try{
        const rs = await apiCall('get', `/api/user`);

        if(rs.code===200){
          rs.result.map(r=>{
            this.accountMap[r.userId] = `[${r.userId}] ${r.name}`;
          });
        }

      }catch(err){
        console.error( err );
        await this.alertDanger(err.message);
      }
    },
    async createArea(){
      // console.log('------------- createArea ---------------');
      let r;
      try{
        r = await apiCall("POST", `/api/area`, _group);
        // console.log( r );
        if(r.code===200){
          await this.getAreaList();
        }
        await this.toastResult(r, `관제지역 등록`);
      }catch(err){
        console.error( err );
        await this.alertDanger(err.message, r.code, 'danger');
      }
    },

    async applyGroup(){
      try{
        if( await setAreas() ){
          await this.alertSuccess('관제지역 정보가 적용 되었습니다. 로그아웃 후 재 로그인이 필요합니다.');
          await this.getAreaList();
        }
      }catch(err){
        console.error(err);
      }
    },

    async getAreaList(){
      try{
        this.rows = [];
        const r = await apiCall('get', `/api/area`);
        if(r.code===200){
          this.rows = r.result;
          await this.toastInfo(`${this.rows.length}건 조회됨`, 'info');
        }
      }catch(err){
        await this.alertDanger(err.message);
        console.error( err );
      }
    },

    async updateCell(rec){
      let rc = rec.pop();
      if(!rc.keys[0]){
        alert( "KEY_NOT_FOUND" );
        return;
      }

      // console.log( "updateRecord--------- record.$id--->",rc.$id );
      // console.log( "updateRecord--------- record.keys[0]--->",rc.keys[0] );

      let r = null;

      let param = {};
      const objectId = rc.keys[0];
      const fieldName = rc.name;
      param[fieldName] = rc.newVal;
      try{
        // console.log( 'param --->', param);
        r = await apiCall("PUT", `/api/area/${objectId}`, param);
        // console.log( r );
        await this.toastResult(r, `${groupColumnMap[fieldName]} 수정`);
      }catch(err){
        console.error( err );
        await this.alertDanger(err.message, r.code, 'danger');
      }
    },

    async deleteRecord(){
      this.isGroupDeleting = true;
      try{
        let params = this.$refs['excelGrid'].getSelectedRecords();
        this.progCount = 0;
        this.totalCount = params.length;
        if(!params.length) return this.toastInfo('[선텍된 레코드 없음] 좌측의 번호를 클릭하여 레코드 선택');

        // console.log( "deleteRecord --- recs ---", recs.length );
        // console.log( "deleteRecord --- params ", params );
        // console.log( "deleteRecord length ----> ", params.length );

        const confirmMsg = `${params.length} 개의 데이터를 삭제 합니다. 삭제된 데이터는 복구할 수 없으며 시스템 장애가 발생할 수 있습니다. 진행 하시겠습니까?`;

        if( !(await this.confirmModal(confirmMsg, '레코드 삭제')) ){
          return;
        }

        let failCnt = 0;
        for( let record of params){
          // console.log( "deleteRecord for --------->", record );
          const tIndex = this.$refs['excelGrid'].rowIndex[record.$id];
          const r = await apiCall('DEL', `/api/area/${record._id}`);
          // console.log( r );
          if( r.code===200 ){
            this.progCount++;
            this.$refs["excelGrid"].deleteRecord(tIndex);
          }else{
            failCnt++;
            this.toastInfo('삭제 에러: '+r.message, 'Error', 'danger' );
          }
        }

        await this.alertModal(`삭제: ${this.progCount}건, 실패: ${failCnt}`, '레코드 삭제결과', 'warning');
        this.$refs['excelGrid'].clearAllSelected();
        await this.getAreaList();

      }catch(err){
        console.error( err );
      }finally{
        this.progCount = 0;
        this.isGroupDeleting = false;
        this.selectedGroup = null;
      }
    },
    onRowSelected(items) {
        if (items.length > 0) {
          this.selectedGroupManager = items[0];
        } else {
          this.selectedGroupManager = null;
        }
        // console.log('Selected Group Manager:', this.selectedGroupManager);
    },
  }
}
</script>

<style scoped>
.dark-mode-select {
  background-color: #333;
  color: #fff;
  border: 1px solid #555;
}

.dark-mode-select .dropdown-item {
  background-color: #333;
  color: #fff;
}

.dark-mode-select .dropdown-item:hover {
  background-color: #444;
}

.dark-mode-select .dropdown-menu {
  background-color: #333;
  border: 1px solid #555;
}

.dark-mode-select option {
  background-color: #333;
  color: #fff;
}

.vue-excel-editor .table-content .systable .center-text .table-col-header {
  pointer-events: none;
}
</style>
